<template>
  <Modal v-model="visible" width="1024" title="保函收讫单" @on-cancel="closeModal">
    <div class="gua-receipt" id="guaReceipt" v-if="guarantee&&guarantee.orderNumber">
      <v-print :doPrint.sync="print">
        <h2 style="text-align: center;">保函收讫单</h2>
        <table class="brief-table">
          <tbody>
            <tr>
              <td class="title">保函编号</td>
              <td>{{guarantee.orderNumber}}</td>
              <td class="title">地区</td>
              <td>{{guarantee.cityName}}</td>
              <td colspan="2" rowspan="6" style="text-align: center;">
                <img :src="qrCodeUrl" v-if="qrCodeUrl" />
                <p class="text-grey small">扫描二维码查询</p>
              </td>
            </tr>
            <tr>
              <td class="title">担保种类</td>
              <td>{{guarantee.varietyName}}</td>
              <td class="title">行业/领域</td>
              <td>{{guarantee.industry?guarantee.industry.name:'-'}}</td>
            </tr>
            <tr>
              <td class="title">项目名称</td>
              <td>{{guarantee.project.name}}</td>
              <td class="title">项目类型</td>
              <td>{{getPrjType(guarantee.project.type).join('/')}}</td>
            </tr>
            <tr>
              <td class="title">项目立项备案号</td>
              <td>{{guarantee.project.filingNo||'-'}}</td>
              <td class="title">规划许可证号</td>
              <td>{{guarantee.project.planLicenseNo||'-'}}</td>
            </tr>
            <tr>
              <td class="title">土地使用证编号</td>
              <td>{{guarantee.project.landLicenceNo||'-'}}</td>
              <td class="title">施工许可证号</td>
              <td>{{guarantee.project.constrLicenceNo||'-'}}</td>
            </tr>
            <tr>
              <td class="title">工程造价</td>
              <td>{{`¥ ${guarantee.project.cost/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元</td>
              <td class="title">建设规模</td>
              <td>{{guarantee.project.area||'-'}}</td>
            </tr>
            <tr>
              <td class="title">计划工期</td>
              <td>
                {{guarantee.project.startdate?require('moment')(guarantee.project.startdate).format('YYYY/MM/DD'):null}}
                -
                {{guarantee.project.finishdate?require('moment')(guarantee.project.finishdate).format('YYYY/MM/DD'):null}}
                <span v-if="guarantee.project.startdate&&guarantee.project.finishdate">({{guarantee.project.duration}}天)</span>
              </td>
              <td class="title"  v-if="guarantee.gMethod===2">总担保金额</td>
              <td colspan="3" v-if="guarantee.gMethod===2">{{`¥ ${totalGuaAmount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元</td>
              <td class="title" v-if="guarantee.gMethod===0">担保金额</td>
              <td colspan="3" v-if="guarantee.gMethod===0">{{`¥ ${guarantee.amount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元</td>
            </tr>
            <tr>
              <td class="title">{{guarantee.gMethod===2?'主':''}}保证人</td>
              <td colspan="5">{{guarantee.guarantor?guarantee.guarantor.name:'-'}}</td>
            </tr>
            <tr>
              <td class="title">受益人</td>
              <td colspan="5">{{guarantee.beneficiary}}</td>
            </tr>
            <tr>
              <td class="title">被保证人</td>
              <td colspan="5">{{guarantee.guaranteed}}</td>
            </tr>
            <tr v-if="guarantee.gMethod===2">
              <td class="title">保证方式</td>
              <td>{{guarantee.gMethod===0?'独立保证':'联合保证'}}</td>
              <td class="title">联保方案</td>
              <td colspan="3">
                <ul class="joint-plan">
                  <li>主承：{{guarantee.guarantor.name}}，{{`¥ ${guarantee.amount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元</li>
                  <li v-for="(j,idx) in guarantee.jointGuarantors" :key="idx">
                    联保{{idx+1}}：{{j.guarantor.name}}，{{`¥ ${j.amount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元
                  </li>
                </ul>
              </td>
            </tr>
            <tr v-if="guarantee.gMethod===2">
              <td class="title">担保费率(%·月)</td>
              <td>{{guarantee.gFeeRate>0?Math.round(guarantee.gFeeRate*100)/100+'%·月':''}}</td>
              <td class="title">保额造价比</td>
              <td colspan="3">{{Math.round(guarantee.amountCostRatio*10000)/100}}%</td>
            </tr>
            <tr v-if="guarantee.gMethod===0">
              <td class="title">担保费率(%·月)</td>
              <td>{{guarantee.gFeeRate>0?Math.round(guarantee.gFeeRate*100)/100+'%·月':''}}</td>
              <td class="title">保额造价比</td>
              <td colspan="3">{{Math.round(guarantee.amountCostRatio*10000)/100}}%</td>
            </tr>
            <tr>
              <td class="title">保函收费起止时间</td>
              <td colspan="5">
                {{require('moment')(guarantee.gStartDate).format('YYYY-MM-DD HH:mm:ss')}}
                &nbsp;~&nbsp;
                {{require('moment')(guarantee.gEndDate).format('YYYY-MM-DD HH:mm:ss')}}
                ({{require('moment')(guarantee.gEndDate).diff(require('moment')(guarantee.gStartDate), 'days')}}天)
                <p v-if="guarantee.gEndDateOri">
                  (原始起止时间：{{require('moment')(guarantee.gStartDate).format('YYYY-MM-DD HH:mm:ss')}}
                &nbsp;~&nbsp;
                {{require('moment')(guarantee.gEndDateOri).format('YYYY-MM-DD HH:mm:ss')}})
                </p>
              </td>
            </tr>
            <tr>
              <td class="title">反担保总额</td>
              <td>{{guarantee.counterCash>0?(guarantee.counterCash+guarantee.counterMortgage+guarantee.counter3rdparty+guarantee.counterOther)/100+'元':''}}</td>
              <td class="title">反担保比例</td>
              <td colspan="3">{{guarantee.counterRatio>0?Math.round(guarantee.counterRatio*10000)/100+'%':''}}</td>
            </tr>
            <tr>
              <td class="title">现金反担保</td>
              <td>{{guarantee.counterCash>0?guarantee.counterCash/100+'元':''}}</td>
              <td class="title">抵押质押</td>
              <td colspan="3">{{guarantee.counterMortgage>0?guarantee.counterMortgage/100+'元':''}}</td>
            </tr>
            <tr>
              <td class="title">第三方反担保</td>
              <td>{{guarantee.counter3rdparty>0?guarantee.counter3rdparty/100+'元':''}}</td>
              <td class="title">其他反担保</td>
              <td colspan="3">{{guarantee.counterOther>0?guarantee.counterOther/100+'元':''}}</td>
            </tr>
            <tr>
              <td class="title">上报人</td>
              <td>{{guarantee.opName}}({{guarantee.opContactTel}})</td>
              <td class="title">录入时间</td>
              <td colspan="3">{{require('moment')(guarantee.createTime).format('YYYY-MM-DD HH:mm:ss')}}</td>
            </tr>
            <tr v-if="[0, 1, 2, 3, 4, 5, 8].indexOf(guarantee.status)>-1">
              <td class="title">预审人</td>
              <td>{{guarantee.preAuditorName}}</td>
              <td class="title">预审时间</td>
              <td colspan="3">{{guarantee.preAuditTime?require('moment')(guarantee.preAuditTime).format('YYYY-MM-DD HH:mm:ss'):''}}</td>
            </tr>
            <tr v-if="[0, 1, 2, 3, 4, 5].indexOf(guarantee.status)>-1">
              <td class="title">审核人</td>
              <td>{{guarantee.auditorName}}</td>
              <td class="title">审核时间</td>
              <td :colspan="[3, 4, 5].indexOf(guarantee.status)>-1?1:3">{{guarantee.auditTime?require('moment')(guarantee.auditTime).format('YYYY-MM-DD HH:mm:ss'):''}}</td>
              <td class="title" v-if="[3, 4, 5].indexOf(guarantee.status)>-1">终止时间</td>
              <td v-if="[3, 4, 5].indexOf(guarantee.status)>-1">{{guarantee.terminateTime?require('moment')(guarantee.terminateTime).format('YYYY-MM-DD HH:mm:ss'):''}}</td>
            </tr>
          </tbody>
        </table>
      </v-print>
    </div>
    <div slot="footer">
      <!-- <i-button @click="print=true">打印</i-button> -->
      <i-button @click="downloadReceipt" style="margin-left:5px">下载</i-button>
      <Button type="default" @click="closeModal" style="margin-left:5px">
        取消
      </Button>
    </div>
  </Modal>
</template>

<script>
// import Api from '../../api/Api.js'
import ExportSavePdf from '@/utils/html2pdf'
import vPrint from 'syl-vue-printer'
import QRCode from 'qrcode'
export default {
  name: 'GuaReceiptModal',
  props: {
    show: Boolean,
    guarantee: Object
  },
  components: {
    vPrint
  },
  data () {
    return {
      visible: false,
      prjTypes: [],
      print: false,
      qrCodeUrl: null
    }
  },
  watch: {
    'show': function (newVal) {
      if (newVal) {
        let host = window.location.host
        QRCode.toDataURL(`http://${host}/#/verify?guanumber=${this.guarantee.orderNumber}`)
          .then(url => {
            this.qrCodeUrl = url
          })
          .catch(err => {
            console.error(err)
          })
      }
      this.visible = newVal
    },
  },
  mounted () {
  },
  methods: {
    downloadReceipt () {
      ExportSavePdf('guaReceipt', '保函收讫单', this.guarantee.orderNumber, 'portrait')
    },
    getSysConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    closeModal () {
      this.visible = false
      this.$emit('close')
    },
    getPrjType (type) {
      let prjType
      if (!this.prjTypes.length) {
        this.initPrjTypes().then((types) => {
          prjType = types.find(o => o.tid === parseInt(type))
        })
      } else {
        prjType = this.prjTypes.find(o => o.tid === parseInt(type))
      }
      if (prjType) {
        let prjTypeCur = [prjType.prjType]
        if (prjType.parentNode) {
          let parentNode = this.prjTypes.find(o => o.tid === prjType.parentNode)
          prjTypeCur.splice(0, 0, parentNode.prjType)
        }
        return prjTypeCur
      } else {
        return []
      }
    },
    async initPrjTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Project.getPrjTypes().then(res => {
          this.prjTypes = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
  }
}
</script>

<style lang="less">
.gua-receipt {

}
</style>